import { HomeIcon } from '@heroicons/react/24/outline';
import { HLX_ROUTES, paths } from '~/routing';
import { getHlxNavIcon } from '~/routing/hlxNavIcons';
import { IconType } from '~/types';

type HlxSidebarItem = {
  href: string;
  icon: IconType;
  label: string;
  pageKey: string;
};

type HlxSidebarSection = {
  label: string;
  subMenu: HlxSidebarItem[];
};

const toNavItem = (path: string, label?: string): HlxSidebarItem => {
  const route = HLX_ROUTES.find((item) => item.path === path);

  if (!route) {
    throw new Error(`Missing HLX route metadata for path: ${path}`);
  }

  const mappedIcon = getHlxNavIcon(path);
  if (!mappedIcon) {
    console.warn(`Missing icon mapping for HLX path: ${path}`);
  }
  const icon = mappedIcon ?? HomeIcon;

  return {
    href: route.path,
    icon,
    label: label ?? route.title,
    pageKey: route.path.split('/').pop() || '',
  };
};

export const HLX_EMPLOYER_SIDEBAR_LINKS: HlxSidebarSection[] = [
  {
    label: 'Home',
    subMenu: [toNavItem(paths.hlx.dashboard), toNavItem(paths.hlx.calendar)],
  },
  {
    label: 'B2B',
    subMenu: [
      toNavItem(paths.hlx.listingSearch, 'B2B Marketplace'),
      toNavItem(paths.hlx.msaasListings),
      toNavItem(paths.hlx.b2bOpportunities, 'B2B Responses'),
      toNavItem(paths.hlx.contracts),
    ],
  },
  {
    label: 'Jobs',
    subMenu: [
      toNavItem(paths.hlx.listings),
      toNavItem(paths.hlx.jobOpportunities, 'Job Responses'),
    ],
  },
  {
    label: 'Provider Services',
    subMenu: [
      toNavItem(paths.hlx.search, 'Search Providers'),
      toNavItem(paths.hlx.serviceOpportunities, 'Provider Responses'),
    ],
  },
  {
    label: 'Organization',
    subMenu: [
      toNavItem(paths.hlx.team),
      toNavItem(paths.hlx.providerAssociations),
      toNavItem(paths.hlx.employerInfo),
      toNavItem(paths.hlx.facilities),
      toNavItem(paths.hlx.billing),
    ],
  },
];

export const HLX_PROVIDER_SIDEBAR_LINKS: HlxSidebarSection[] = [
  {
    label: 'Home',
    subMenu: [toNavItem(paths.hlx.calendar)],
  },
  {
    label: 'Marketplace',
    subMenu: [
      toNavItem(paths.hlx.listings, 'Job Search'),
      toNavItem(paths.hlx.jobOpportunities, 'Job Opportunities'),
      toNavItem(paths.hlx.myServices),
      toNavItem(paths.hlx.serviceOpportunities),
      toNavItem(paths.hlx.contracts),
    ],
  },
];
